import { useEffect } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import { getJourneyState } from "../../../../Utils/onboarding/getJourneyState"
import { BA_STEPS } from "../../../GettingStartedPage/utils/businessSteps"
import { getMaxCreateSteps } from "../../../User/redux/user.thunks"
import { createSteps } from "../../utils/constants/createSteps"
import { getAlertSubSteps } from "../../utils/helpers/getAlertSubSteps"
import { getStepState } from "../../utils/helpers/getStepState"
import OnboardingStep from "../OnboardingStep"
import OnboardingSubStep from "../OnboardingSubStep"

import "../../styles.less"

const BusinessSideBar = ({ showSubSteps }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const userInfo = useSelector((state) => state.auth.userInfo)
  const userState = useSelector((state) => state.user)
  const enrollments = useSelector((state) => state.user.enrollments)
  const journey = getJourneyState({
    userInfo,
    userState,
    pathname
  })

  useEffect(() => {
    dispatch(getMaxCreateSteps())
  }, [])

  const steps = createSteps(BA_STEPS).slice(0, journey.steps.length)
  const isAlertPage = pathname.includes("/alerts")

  const activeEnrollments = enrollments?.filter((enrollment) => enrollment.is_active)
  const isActiveRDR = activeEnrollments.some((enrollment) => enrollment.name === "RDR")

  return (
    <div className="ob-steps">
      {steps.map((s, i) => {
        const { done, active, block, isProcess, isSub } = getStepState(
          s.stepId,
          journey.currentStep,
          BA_STEPS,
          showSubSteps,
          isAlertPage
        )

        return (
          <>
            <OnboardingStep
              key={s.key}
              label={s.label}
              done={done}
              active={active}
              process={isProcess}
              sub={isSub}
              onClick={() => {
                if (block) return
                navigate(`/create-account/${s.key}`)
              }}
            />

            {isSub && (
              <div className="ob-subSteps">
                {getAlertSubSteps(showSubSteps, s.subSteps)
                  .filter((ss) => ss.key !== "bin" || isActiveRDR)
                  .map((ss) => (
                    <OnboardingSubStep key={ss.key} {...ss} />
                  ))}
              </div>
            )}
          </>
        )
      })}
    </div>
  )
}

export default BusinessSideBar
